import React, { useState } from 'react'
import { Dialog, Button } from 'element-react'

const DialogSG = () => {
    const [dialogVisible, setDialogVisible] = useState(false)

    return (
        <div>
            <Button type="text" onClick={() => setDialogVisible(true)}>
                Click to open the Dialog
            </Button>
            {dialogVisible && (
                <Dialog
                    title="Tips"
                    size="tiny"
                    visible={true}
                    onCancel={() => setDialogVisible(false)}
                    lockScroll={false}
                >
                    <Dialog.Body>
                        <span>This is a message</span>
                    </Dialog.Body>
                    <Dialog.Footer className="dialog-footer">
                        <Button onClick={() => setDialogVisible(false)}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => setDialogVisible(false)}
                        >
                            Confirm
                        </Button>
                    </Dialog.Footer>
                </Dialog>
            )}
        </div>
    )
}

export default DialogSG
